var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenUserSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C39.3638 32 45.3333 26.0305 45.3333 18.6667C45.3333 11.3029 39.3638 5.33337 32 5.33337C24.6362 5.33337 18.6667 11.3029 18.6667 18.6667C18.6667 26.0305 24.6362 32 32 32Z",
    fill: "#197C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32 38.6666C18.64 38.6666 7.75993 47.6266 7.75993 58.6666C7.75993 59.4133 8.3466 60 9.09327 60H54.9067C55.6534 60 56.2401 59.4133 56.2401 58.6666C56.2401 47.6266 45.36 38.6666 32 38.6666Z",
    fill: "#197C36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7201 55.1466L58.6934 53.1199C59.76 51.5199 60.3734 49.6 60.3734 47.5467C60.3734 41.92 55.8134 37.36 50.1867 37.36C44.56 37.36 40 41.92 40 47.5467C40 53.1733 44.56 57.7334 50.1867 57.7334C52.24 57.7334 54.1599 57.12 55.7599 56.0533L57.7866 58.08C58.1866 58.48 58.7199 58.6933 59.2533 58.6933C59.7866 58.6933 60.3201 58.48 60.7201 58.08C61.5467 57.2534 61.5467 55.9466 60.7201 55.1466Z",
    fill: "#197C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUserSearch);
export default __webpack_public_path__ + "static/media/green_user-search.d967e64a519ca61281b5425502c729ca.svg";
export { ForwardRef as ReactComponent };